import React from "react";
import dynamicfunction from "../utils/dynamicfunction";

const ErrorText = ({ text = "", numbers, className, getContentKey, isCenter }) => {
  const { TextWeight, TextAlign, isArabic } = dynamicfunction();

  if (!text) return null;

  return (
    <p
      className={`text-red text-xs mt-2 ${TextWeight.light} ${isCenter ? "text-center" : TextAlign}  ${className}`}
    >
      {getContentKey ? getContentKey(text) : text} {numbers}
    </p>
  );
};

export default ErrorText;
